import axios from "axios";

const SERVICES_URL = process.env.REACT_APP_SERVICES_URL + "/api";
const OAUTH_URL = process.env.REACT_APP_SERVICES_URL + "/oauth/token";

class AuthApi {
  getToken = (body, refresh) => {
    const client = btoa("comptix:secret");
    let request = {
      url: OAUTH_URL,
      method: "post",
      headers: {
        Authorization: `Basic ${client}`,
        "Content-Type": "application/x-www-form-urlencoded"
      },
      data: body
    };
    if (refresh) {
      request.headers.addToken = true;
    }
    return axios(request)
      .then(response => response.data)
      .catch(error => error);
  };

  getUserInfo = () => {
    const url = SERVICES_URL + "/login/user";
    return axios.get(url).then(response => response.data.entity);
  };

  getLoginService = username => {
    const client = btoa("comptix:secret");
    let request = {
      url: OAUTH_URL + "/login/service?username=" + username,
      method: "get",
      headers: {
        Accept: "application/json",
        Authorization: `Basic ${client}`
      }
    };
    return axios(request)
      .then(response => response.data)
      .catch(error => error.response);
  };
}

export default AuthApi;
